module.exports = __webpack_public_path__ + "static/media/speaker2025.e29ed83c.png";